// extracted by css-extract-rspack-plugin
export default {"emptyState":"Labels-module__emptyState__dTJDz"};